import React from 'react';
import {
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

export default {
  uiSchema: {
    wantsToWaiveSubstitution: yesNoUI({
      title:
        'Do you want to continue any pending claims the original claimant had with VA?',
      labelHeaderLevel: '3',
      yesNoReverse: true,
      tile: true,
      description: (
        <p>
          If the original claimant had a pending claim for benefits that hadn’t
          been decided yet, or the claim was decided and the period to file a
          review has not yet expired, you can choose to continue that claim on
          their behalf. You can also elect to allow VA to decide based on only
          the evidence they already have. You don’t have to decide now - you can
          ask about pending claims later.
        </p>
      ),
      labels: {
        Y: 'Yes, I want to continue the pending claim (I may submit more evidence and/or file a review option)',
        N: 'No, VA should decide the claim based on the information in VA’s records. (waive substitution)',
      },
      descriptions: {
        Y: 'For example, choose this if you wish to submit medical records, statements, or file a review option on a claim that VA decided.',
        N: 'For example, choose this if you want VA to decide based only on the information they already have.',
      },
    }),
  },
  schema: {
    type: 'object',
    properties: {
      wantsToWaiveSubstitution: yesNoSchema,
    },
  },
};
